export type StrapiRole = string;

function normalizeRole(role: StrapiRole): string {
    return role.trim().toLowerCase();
}

export function hasStrapiRole(roles: readonly StrapiRole[] | undefined, expectedRole: StrapiRole): boolean {
    const normalizedExpectedRole = normalizeRole(expectedRole);

    return (roles ?? []).some((role) => normalizeRole(role) === normalizedExpectedRole);
}

/** Strapi's authenticated role type grants access to the frontend editor. */
export function hasEditorRights(roles: readonly StrapiRole[] | undefined): boolean {
    return hasStrapiRole(roles, "admin") || hasStrapiRole(roles, "editor");
}

export function hasAdminRights(roles: readonly StrapiRole[] | undefined): boolean {
    return hasStrapiRole(roles, "admin");
}
